import React from 'react'
import { Bars } from 'react-loader-spinner'
import './ATLoader.css'
const ATLoader: React.FC = () => {
  return (
    <div className="loader_background d-flex align-items-center justify-content-center">
      <Bars
        height="40"
        width="40"
        color="#198ed6"
        ariaLabel="bars-loading"
        wrapperStyle={{ fill: 'red' }}
        wrapperClass=""
        visible={true}
      />
    </div>
  )
}

export default ATLoader
